<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="更换背景"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">
        <el-form-item label="" prop="theme_img">
        <div class="imgs">
          <div v-for="(item,index) in  themeImgs" :key="index" @click="selectImg(index)" :class="item.selected?'active' : ''">
              <el-image :src="item.img_url" >
              <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
              </div>
            </el-image>
          </div>
          
        </div>
        </el-form-item>
      
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>


  </el-dialog>
</template>

<script>
import { recommendupdate ,themeImg} from "@/api/user/index.js";

export default {
  components: { },

  data() {
    return {
      visible: false,
      themeImgs:[],
      
      formData: {
        theme_img:"",
      },
       rules: {
        theme_img: [
              {required: true, message: '请输入专业', trigger: 'change'}
          ],
       }
    };
  },

 
  mounted() {
    console.log("asdasdasd")

},
  
  methods: {
    init() {
      this.initData();
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
      this.$refs["form"].resetFields();

    },

   

    initData(){
      var that=this;
      themeImg({}).then((response) => {
        console.log(response);
        if(response.code==200){
          that.themeImgs=response.data
        }else{
          this.$message({
            message: response.msg?response.msg:"获取背景图失败",
          });
        }
      });
    },

    selectImg(index){
      console.log(index)
     
      this.themeImgs.forEach(item => {
        item.selected=false;
      });

      this.themeImgs[index].selected=true;
      this.formData.theme_img= this.themeImgs[index].img_url

        console.log( this.themeImgs)
        this.$forceUpdate();

    },

   
    
    
    submit(){
      var that=this;
      this.$refs["form"].validate((valid) => {
          if (valid) {
            recommendupdate(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'

                });
                that.$emit('refresh');
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });

    },

    
  },

 
};
</script>

<style lang="scss" scoped>
 .imgs .active{
  border: 3px solid blue !important;
  padding: 10px;
}

::v-deep .el-form-item__content{
  margin-left: 0px !important;
}


::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}





/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
